import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import config from "../../../../config";
import TextField from '../../Textfield';
import Button from '../../Button'
import Select from 'react-select';
import './Filter.css';
var imm = require('immutable');


class Filter extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: imm.Map(props.queryParams),
            loading: true,
            expanded: false
        }
    }

    componentWillMount() {
        this.loadDefaults();
    }

    loadDefaults() {
        if (this.props.userfilter === undefined)
            return;

        this.props.userfilter.map(function (row, i) {
            if (row.type === 'date_range') {
                // Check queryParams first, then fall back to defaults
                const fromParam = this.props.queryParams?.find(param => param.key === row.source + '_from');
                const toParam = this.props.queryParams?.find(param => param.key === row.source + '_to');
                
                if (fromParam && toParam) {
                    this.setState((state) => ({
                        data: state.data.set(row.source + '_from', fromParam.value).set(row.source + '_to', toParam.value)
                    }));
                } else if (row.default !== undefined) {
                    this.setState((state) => ({
                        data: state.data.set(row.source + '_from', row.default.from).set(row.source + '_to', row.default.to)
                    }));
                }
            } else if (row.type === 'select') {

            } else {
                if (row.default !== undefined) {
                    this.setState((state) => ({
                        data: state.data.set(row.source, row.default)
                    }))
                }
            }
        }, this);
    }

    handleChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }));
    }
    handleDateChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value.format())
        }));
    }
    handleDateRangeFromChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }))
    }
    handleDateRangeToChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }))
    }
    handleSelectChange(key, value) {
        if (value === null) {
            return;
        }
        var val = value.value;
        this.setState((state) => ({
            data: state.data.set(key, val)
        }));
    }
    componentWillReceiveProps() {
        this.setState({loading: false})
    }

    handleFilter() {
        this.setState({loading: true}, this.props.onFilter(this.state.data.toJS()));
    }
    handleClear() {
        this.setState({loading: true, data: this.state.data.set('search', '')}, 
            () => {
                this.loadDefaults();
                this.props.onFilter(this.state.data.toJS());
            }
        );
    }
    handleExpand() {
        this.setState((state) => ({
            expanded: !state.expanded
        }));
    }
    render() {
        const expanded = this.state.expanded;
        const userFilterExpandable = this.props.userFilterExpandable;
        const userFilterAdvanced = this.props.userFilterAdvanced;
        const columnWidth = this.props.filterColumnWidth ? this.props.filterColumnWidth : 4;
        if (this.props.userfilter === undefined)
            return null;
        let csv_link = config.apiGateway.URL + this.props.url;
        if (this.props.urlattrs !== undefined) {
            for (var key in this.props.urlattrs) {
                var repl = '{$' + key + '}';
                csv_link = csv_link.replace(repl, this.props.urlattrs[key]);
            }
        }
        csv_link = csv_link + '?export=1&method=get';
        this.props.userfilter.map(function (row, i) {
            if (row.type === 'date_range') {
                csv_link = csv_link + '&' + row.source + '_from=' + this.state.data.get(row.source + '_from') + '&' + row.source + '_to=' + this.state.data.get(row.source + '_to') ;
            } else {
                csv_link = csv_link + '&' + row.source + '=' + this.state.data.get(row.source);
            }
        }, this);


        return (
            <div className="card">
                <div className="card-body">
                    <form className="form-vertical">
                        <div className="row">
                            <div className="col-lg-12">
                                {this.props.userFilterSimple && ! (userFilterExpandable && expanded) && (
                                <div className="basic-search-bar"> 
                                    <div className="col-sm-2 input-group">
                                        <TextField
                                            label=""
                                            type="text"
                                            value={this.state.data.get('search')}
                                            onChange={this.handleChange.bind(this, 'search')}
                                            className="form-control"
                                            onKeyDown={this.handleFilter.bind(this)}
                                        />
                                    </div>
                                    <Button bsStyle="success" disabled={this.props.loading} icon="search" value="Search" onClick={this.handleFilter.bind(this)}>
                                        Search
                                    </Button>
                                    <Button bsStyle="cancel" disabled={this.props.loading} value="Reset" onClick={this.handleClear.bind(this)}/>
                                    {userFilterExpandable && <span className="expand-filter-button" disabled={this.props.loading} onClick={this.handleExpand.bind(this)}><i className="material-icons">{expanded ? "expand_less" : "expand_more"}</i></span>}
                                </div>
                                )}
                            </div>
                            <div className="col-lg-12">
                            {
                                ((userFilterExpandable && expanded) || userFilterAdvanced) && this.props.userfilter.map(function (row, i) {
                                    // condition check
                                    var src = row.source;
                                    if (row.type === 'text') {
                                        return (
                                            <div key = {i} className={`form-group col-lg-${columnWidth}`}>
                                                <label
                                                    className="col-sm-3 control-label"
                                                    htmlFor={src}>{row.label}</label>
                                                <div className="col-sm-9 input-group">
                                                    <TextField
                                                        label= ''
                                                        type='text'
                                                        value={ this.state.data.get(src) }
                                                        onChange={ this.handleChange.bind(this, src) }
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                        );
                                    } else if (row.type === 'date_range') {
                                        var d1 = new Date(this.state.data.get(src + '_from'));
                                        var d2 = new Date(this.state.data.get(src +'_to'));
                                        return (
                                            <div key = {i} className={`form-group col-lg-${columnWidth}`}>
                                                <label
                                                    className="col-sm-3 control-label"
                                                    htmlFor={src}>{row.label} from</label>
                                                <div className="col-sm-9 input-group">
                                                    <DatePicker
                                                        className="form-control datepicker"
                                                        selected={ d1 }
                                                        onChange={ this.handleDateRangeFromChange.bind(this, src + '_from') }
                                                        showTimeSelect
                                                        timeFormat="HH:mm"
                                                        dateFormat="yyyy-MM-dd HH:mm"
                                                    />
                                                </div>
                                                <div
                                                    className="col-sm-3">to
                                                </div>
                                                <div className="col-sm-9 input-group">
                                                    <DatePicker
                                                        className="form-control datepicker"
                                                        selected={ d2 }
                                                        onChange={ this.handleDateRangeToChange.bind(this, src + '_to') }
                                                        showTimeSelect
                                                        timeFormat="HH:mm"
                                                        dateFormat="yyyy-MM-dd HH:mm"
                                                    />
                                                </div>
                                            </div>
                                        )
                                    } else if (row.type === 'select') {
                                        var meta = this.props.data.metadata?.[row.source];
                                        var options = [];
                                        if (row.options !== undefined) {
                                            if (row.options.empty) {
                                                var options = [{value: 0, label: '--'}];
                                            }
                                        }
                                        var defaultSelect = {value: 0, label: '--'};
                                        if (meta !== undefined) {
                                            Object.keys(meta.values).map(function (i) {
                                                options.push({value: i, label: meta.values[i]});
                                                if (i === this.state.data.get(row.source)) {
                                                    defaultSelect = {value: i, label: meta.values[i]}
                                                }
                                            }, this);
                                        }
                                        return (
                                            <div key={i} className={`form-group col-lg-${columnWidth}`}>
                                                <label
                                                    className="col-sm-3 control-label"
                                                    htmlFor={row.source}>{row.label}</label>
                                                <div className="col-sm-9 input-group">
                                                    <Select
                                                        name={row.source}
                                                        options={options}
                                                        selected={this.state.data.get(row.source)}
                                                        id={row.source}
                                                        placeholder={row.label}
                                                        value={defaultSelect}
                                                        onChange={this.handleSelectChange.bind(this, row.source)}
                                                    />
                                                </div>
                                            </div>
                                        )   
                                    }
                                }, this)
                            }
                            {((userFilterExpandable && expanded) || userFilterAdvanced) && (
                                <div className="col-lg-4 pull-right" style={{ textAlign: 'right' }}>  
                                    <Button bsStyle="success" disabled={this.props.loading} icon="search" value="Search" onClick={this.handleFilter.bind(this)}>
                                        Search
                                    </Button>
                                    <Button bsStyle="cancel" disabled={this.props.loading} value="Reset" onClick={this.handleClear.bind(this)}/>
                                </div>
                            )}

                            </div>
                        </div>
                    </form>
                </div>
                {/* <div className="card-footer">
                     { this.props.download &&
                    <div
                        type="button"
                        className="btn btn-download pull-right"
                    ><a className="a-btn-download" href={ csv_link }>Export CSV</a></div>
                    }
                </div> */}
            </div>
        )
    }
}

export default Filter;